<template>
  <table class="w-full text-xs bg-white border border-gray-200">
    <thead>
      <tr class="bg-gray-50 border-b border-gray-200 text-left text-gray-500">
        <th class="p-2 font-medium">ID</th>
        <th class="p-2 font-medium">Pri</th>
        <th class="p-2 font-medium">Created</th>
        <th class="p-2 font-medium">Requirement</th>
        <th class="p-2 font-medium">Queue</th>
        <th class="p-2 font-medium">Delivery</th>
        <th class="p-2 font-medium">Tenant</th>
        <th class="p-2 font-medium">Owner</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!tickets.length">
        <td colspan="8" class="p-2 text-gray-500">No requirements in this queue.</td>
      </tr>
      <tr
        v-for="ticket in tickets"
        :key="ticket.id"
        class="border-b border-gray-100 cursor-pointer"
        :class="ticket.id === selectedId ? 'bg-gray-100' : 'hover:bg-gray-50'"
        @click="$emit('select', ticket.id)"
      >
        <td class="p-2 text-gray-500">{{ ticket.requirement }}</td>
        <td class="p-2" :class="ticket.requirement_priority === 'p0' ? 'font-medium' : ''">
          {{ priorityLabel(ticket.requirement_priority) }}
        </td>
        <td class="p-2 text-gray-600">{{ shortDate(ticket.requirement_created_at) }}</td>
        <td class="p-2">
          {{ ticket.requirement_title }}
          <div class="text-gray-500">
            {{ ticket.requirement_type }} · {{ ticket.requirement_status }}
          </div>
        </td>
        <td class="p-2" :class="ticket.investigated ? '' : 'text-gray-400'">
          {{ queueLabels(ticket) }}
        </td>
        <td class="p-2 text-gray-600">
          {{ ticket.investigated ? deliveryLabel(ticket.delivery) : '' }}
        </td>
        <td class="p-2 text-gray-600">{{ ticket.tenant_name || '—' }}</td>
        <td class="p-2 text-gray-600">{{ ticket.owner_name || 'Unassigned' }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import {
  DELIVERY_LABELS, PRIORITY_LABELS, QUEUE_LABELS, label,
} from './hades_constants';

export default {
  name: 'Hades_TicketTable',
  props: {
    tickets: { type: Array, required: true },
    selectedId: { type: Number, default: null },
  },
  emits: ['select'],
  methods: {
    queueLabels(ticket) {
      return (ticket.queues || []).map((q) => label(QUEUE_LABELS, q)).join(', ');
    },
    deliveryLabel(delivery) {
      return label(DELIVERY_LABELS, delivery);
    },
    priorityLabel(priority) {
      return PRIORITY_LABELS[priority] || priority || '—';
    },
    shortDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleDateString(undefined,
        { year: '2-digit', month: 'short', day: 'numeric' });
    },
  },
};
</script>
